"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultBtn = exports.ButtonChildren = exports.ButtonContent = exports.LoadingFeedback = exports.Icon = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _colors = _interopRequireDefault(require("../../constants/colors"));
function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  display: block;\n  position: relative;\n  padding: 0 30px;\n  height: 40px;\n  border: 0;\n  border-radius: 2px;\n  cursor: pointer;\n  background-color: ", ";\n  transition: opacity 150ms ease-in-out;\n\n  ", " {\n    color: ", ";\n  }\n\n  &:focus {\n    outline: none;\n  }\n\n  &:hover {\n    opacity: 0.8;\n  }\n\n  &:disabled {\n    // cursor: no-drop;\n    opacity: 0.5;\n  }\n\n  &.loading {\n    opacity: 0.5;\n\n    ", " {\n      opacity: 1;\n      transform: translate(-", "px);\n    }\n\n    ", " {\n      transform: translate(", "px);\n    }\n  }\n"]);
  _templateObject5 = function _templateObject5() {
    return data;
  };
  return data;
}
function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  align-items: center;\n  font-size: 15px;\n  transition: 0.3s;\n\n  ", "\n"]);
  _templateObject4 = function _templateObject4() {
    return data;
  };
  return data;
}
function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n"]);
  _templateObject3 = function _templateObject3() {
    return data;
  };
  return data;
}
function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  position: relative;\n  height: 100%;\n  opacity: 0;\n  transition: 0.3s;\n\n  > span {\n    position: absolute;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n"]);
  _templateObject2 = function _templateObject2() {
    return data;
  };
  return data;
}
function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  svg {\n    min-height: 10px;\n    height: 100%;\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
var Icon = _styledComponents["default"].span(_templateObject());
exports.Icon = Icon;
var LoadingFeedback = _styledComponents["default"].div(_templateObject2());
exports.LoadingFeedback = LoadingFeedback;
var ButtonContent = _styledComponents["default"].div(_templateObject3());
exports.ButtonContent = ButtonContent;
var ButtonChildren = _styledComponents["default"].div(_templateObject4(), function (props) {
  return props.textStyle;
});
exports.ButtonChildren = ButtonChildren;
var DefaultBtn = _styledComponents["default"].button(_templateObject5(), function (props) {
  return _colors["default"][props.colorType] || _colors["default"]["default"];
}, ButtonChildren, function (props) {
  return props.colorType === "primary" ? "#fff" : "#383838";
}, LoadingFeedback, function (props) {
  return props.loadingSize / 2 + 2;
}, ButtonChildren, function (props) {
  return props.loadingSize / 2 + 2;
});
exports.DefaultBtn = DefaultBtn;